import CustomTag from "src/models/accounting-calendar/CustomTag";

export type FormMode = 'closed' | 'create' | 'edit';

export interface AccountingCalendarState {
    /** Month being viewed, 1-12. */
    viewMonth: number;
    /** Year being viewed (current year — the only year the backend serves). */
    viewYear: number;
    /** Tag whose details popover is open, if any. */
    selectedTag: CustomTag | null;
    /** Whether the create/edit form is open and in which mode. */
    formMode: FormMode;
    /** Whether the delete confirmation dialog is open. */
    deleteDialogOpen: boolean;
    /** Bumped after a successful mutation to force the calendar to re-fetch. */
    reloadKey: number;
}

export function buildInitialState(currentMonth: number, currentYear: number): AccountingCalendarState {
    return {
        viewMonth: currentMonth,
        viewYear: currentYear,
        selectedTag: null,
        formMode: 'closed',
        deleteDialogOpen: false,
        reloadKey: 0,
    };
}
